import React, {forwardRef} from "react";
import {css} from "@emotion/react";

interface IProps {
    src?: string;
    className?: string;
}

export const ReelDetailsVideo = forwardRef<HTMLVideoElement, IProps>((props, videoRef) => {
    return props.src ? (
        <video ref={videoRef} css={videoStyle} className={props.className} playsInline>
            <source src={props.src} type="video/mp4" />
            Twoja przeglądarka nie obsługuje odtwarzacza video.
        </video>
    ) : null;
});

const videoStyle = css`
    width: 100%;
    height: auto;
`;
import React, {forwardRef} from "react";
import {css} from "@emotion/react";

interface IProps {
    src?: string;
    className?: string;
}

export const ReelDetailsVideo = forwardRef<HTMLVideoElement, IProps>((props, videoRef) => {
    return props.src ? (
        <video ref={videoRef} css={videoStyle} className={props.className} playsInline>
            <source src={props.src} type="video/mp4" />
            Twoja przeglądarka nie obsługuje odtwarzacza video.
        </video>
    ) : null;
});

const videoStyle = css`
    width: 100%;
    height: auto;
`;
